var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8332 0.333313H2.49984C1.2165 0.333313 0.178171 1.38331 0.178171 2.66665L0.166504 21.3333C0.166504 22.6166 1.20484 23.6666 2.48817 23.6666H16.4998C17.7832 23.6666 18.8332 22.6166 18.8332 21.3333V7.33331L11.8332 0.333313ZM14.1665 19H4.83317V16.6666H14.1665V19ZM14.1665 14.3333H4.83317V12H14.1665V14.3333ZM10.6665 8.49998V2.08331L17.0832 8.49998H10.6665Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentGreenIcon);
export default __webpack_public_path__ + "static/media/document-green_icon.a862fd3f5edae63bfb86e88bedef8e4e.svg";
export { ForwardRef as ReactComponent };